import { useTheme } from 'styled-components';

import useGetCompanyEmployeeAvgService from '~hooks/query/company/useCompanyEmployeeAvgService';
import useGetMyInfoQuery from '~hooks/query/user/useMyInfoQuery';
import { isNil } from '~utils/lodash/is';

import { DEFAULT_OPTIONS } from './constant';
import { EmployeeAvgYear } from './type';

interface Props {
  year: EmployeeAvgYear;
}

export function useChart({ year }: Props) {
  const theme = useTheme();
  const chartData = useChartData(year);
  const { isActiveUser } = useGetMyInfoQuery();

  const labels = chartData.length === 3 ? [year, '업계 평균', '전체 평균'] : [year, '전체 평균'];

  const { scales, plugins, ...res } = DEFAULT_OPTIONS;
  const options = {
    ...res,
    plugins: {
      ...plugins,
      datalabels: {
        ...plugins.datalabels,
        labels: {
          ...plugins.datalabels.labels,
          value: {
            ...plugins.datalabels.labels.value,
            formatter: (value: number) =>
              plugins.datalabels.labels.value.formatter(value, isActiveUser),
          },
        },
      },
    },
    scales: {
      ...scales,
      y: {
        ...scales.y,
        max: Math.max(...chartData) * 1.4,
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        backgroundColor: [theme.colors.greypurple300, theme.colors.gray400, theme.colors.gray400],
        borderColor: [theme.colors.greypurple300, theme.colors.gray400, theme.colors.gray400],
        borderWidth: 1,
        barThickness: 30,
        borderRadius: 3,
        data: chartData,
      },
    ],
  };

  return { options, data };
}

export function useChartData(year: 2019 | 2020 | 2021) {
  // react-query
  const { data: employeeAvgService } = useGetCompanyEmployeeAvgService();

  const yearData = employeeAvgService?.get(String(year));
  if (isNil(yearData?.sectionAvgYear)) {
    return [yearData?.avgServiceYear ?? 0, yearData?.allAvgYear ?? 0];
  }

  return [yearData?.avgServiceYear ?? 0, yearData?.sectionAvgYear ?? 0, yearData?.allAvgYear ?? 0];
}
